import State from "slotworks/state-machine/states/state";
import RespinComponent from "components/respin/respin-component";

export default class Respins extends State {

    public onEnter() {
        const respinComponent = new RespinComponent();
        respinComponent.start().then(() => {
            respinComponent.end();
            setTimeout(() => this.complete(), 800);
        });
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/respins.ts